// extracted by mini-css-extract-plugin
export default {"menu-soon-wrapper":"OnePageStyleSoon_menu-soon-wrapper__wKY7W","soon":"OnePageStyleSoon_soon__nNlFS"};